import API, { defaultHeaders, IRI } from '@/api';

const me = (headers = {}) => {
  Object.assign(headers, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
  return fetch(`${API}${IRI.user}${IRI.me}`, { headers });
};

export default me;
